import React from "react";

export const SuccessStep = ({ setStep, onClose }) => (
  <>
    <div className="authorise-bank-transfer-header">
      <h4 className="authorise-bank-transfer-title yellow">Success!</h4>
    </div>
    <div className="authorise-bank-transfer-body-content">
      <div className="authorise-bank-transfer-description black text-center">
        <p>{Drupal.t("The bank transfer has been initiated.")}</p>
      </div>
      {onClose && (
        <div className="authorise-bank-transfer-actions text-center mt-3">
          <button
            type="button"
            className="primary_btn"
            onClick={() => setStep?.("close") || onClose?.()}
          >
            {Drupal.t("Done")}
          </button>
        </div>
      )}
    </div>
  </>
);
